export type LOCALE_MAPPING = Record<string, string>;

export const ANGULAR_LOCALES: LOCALE_MAPPING[] = [
	{ de: "de" },
	{ en: "en" },
	{ fr: "fr" },
	{ it: "it" },
	{ hu: "hu" },
	{ cs: "cs" },
	{ "sr-Latn": "sr-Latn" },
	{ bs: "bs-Latn" },
	{ sk: "sk" },
	{ bg: "bg" },
	{ ro: "ro" },
];

export const MOMENT_LOCALES: LOCALE_MAPPING[] = [
	{ de: "de" },
	{ en: "en-gb" },
	{ fr: "fr" },
	{ it: "it" },
	{ hu: "hu" },
	{ cs: "cs" },
	{ sr: "sr" },
	{ bs: "bs" },
	{ sk: "sk" },
	{ bg: "bg" },
	{ ro: "ro" },
];

export const MOBISCROLL_LOCALES: LOCALE_MAPPING[] = [
	{ de: "de" },
	{ en: "en-GB" },
	{ fr: "fr" },
	{ it: "it" },
	{ hu: "hu" },
	{ cs: "cs" },
	{ "sr-Latn": "sr-Latn" },
	{ bs: "bs" },
	{ sk: "sk" },
	{ bg: "bg" },
	{ ro: "ro" },
];

export const BUILTIN_LOCALES: LOCALE_MAPPING[] = [
	{ de: "de" },
	{ en: "en" },
	{ fr: "fr" },
	{ it: "it" },
	{ hu: "hu" },
	{ cs: "cs" },
	{ "sr-Latn": "sr-Latn" },
	{ bs: "bs-Latn" },
	{ sk: "sk" },
	{ bg: "bg" },
	{ ro: "ro" },
];
